import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router-dom'
import { Form, TreeSelect } from 'antd'

import PopupModal from 'Shared/Components/PopupModal'
import { FormContainer, Dropdown } from 'Shared/Components/FormComponents'

const FilterFormContent = ({ filterRef, onFilter }) => {
	const { setPageLoading, orgProjects } = useOutletContext()
	const { t } = useTranslation()

	const [form] = Form.useForm()

	const initialValues = {
		"project": filterRef.current.project
	}

  return (
		<FormContainer form={form} onFinish={onFilter} initialValues={initialValues}>
			<Dropdown field_name={t("general_project")} field_id="project" props={{ "options": orgProjects }} />
		</FormContainer>
		
  )
}

const FilterForm = ({ filterRef, isOpen, toggleForm, onFilter }) => {
  return (
		<PopupModal isOpen={isOpen} maxHeight="50%" width="70%" close toggle={toggleForm}>
			<FilterFormContent filterRef={filterRef} onFilter={onFilter}/>
		</PopupModal>
  )
}

export default FilterForm
